import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import MainContent from "../../containers/shared/MainContent";
import PageMain from "../../containers/shared/PageMain";
import NormalFormContainer from "../../containers/shared/NormalFormContainer";
import apiClient from "../../components/utils/apiClient";
import { useEffect, useRef, useState } from "react";
import Loading from "../../components/shared/Loading";
import ModalContainer from "../../containers/shared/ModalContainer";
import NormalButton from "../../components/shared/NormalButton";
import MultiSelect from "../../components/shared/MultiSelect";
import InputField from "../../components/shared/InputField";
import Toast from "../../components/shared/Toast";
import SingleImageCompress from "../../components/helpers/SingleImageCompress";
import {initializeApp, getApp, getApps} from "firebase/app";
import { getStorage } from "firebase/storage";
import { getDownloadURL, uploadBytesResumable, ref } from "firebase/storage";
import { firebaseConfig } from "../../components/utils/constants";
import moment from "moment";
import GetServiceByCode from "../../components/helpers/GetServiceByCode";
import { useTranslation } from "react-i18next";

const CompleteRequset = () => {
    const {t, i18n} = useTranslation();

    useDocumentTitle(t('completeRequest.closeRequest'));
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const pageTitle = {title: t('requests.requestNumber')+id, subTitle: ''};
    const [singleRequest, setSingleRequest] = useState(null);
    const [fields, setFields] = useState([]);
    const [completeRequestData, setCompleteRequestData] = useState(null);
    const [isActionLoading, setIsActionLoading] = useState(false);
    const [addServiceModal, setAddServiceModal] = useState(false);
    const [services, setServices] = useState([]);
    const [selectedService, setSelectedService] = useState(null);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [toast, setToast] = useState({show: false,type: null, message:'' });
    const [compressedImage, setCompressedImage] = useState(null);
    const [isMainButtonDisabled, setIsMainButtonDisabled] = useState(true);

    const navigate = useNavigate();




    const fileRef = useRef();

    const ResetInputFile = () => {
        if(fileRef.current) {
            fileRef.current.value = '';
        }
    }

    const handleChangeUpload = (e) => {
        SingleImageCompress(e.target.files[0]).then(compressedFile=>setCompressedImage(compressedFile));
    }


    useEffect(()=>{
        if(compressedImage) {
            ResetInputFile();
        }
    },[compressedImage])


    const getSingleRequest = async () => {
        try {
          const response = await apiClient.get(`/requests/vendor-prettyId?requestPrettyId=${id}${searchParams.get('business') ? `&business=${searchParams.get('business')}` : ''}`);
          if(response?.data) {
            if(response?.data?.paymentStatuses && Array.isArray(response?.data?.paymentStatuses) && response?.data?.paymentStatuses?.length > 0 && ['requested','proceed','done','paid'].includes(response?.data?.paymentStatuses[response?.data?.paymentStatuses?.length-1]?.status)) {
                navigate(`/${i18n?.language || 'ar'}/invoice-status/${id}`);
            }
            setSingleRequest(response?.data);
          } else {

          }
        } catch(err) {}
    }


    const getFields = async () => {
        try {
          const response = await apiClient.get(`/fields`);
          if(response?.data) {
            setFields(response?.data);
            const serviceObject = response?.data?.find(item=>item?.field?.code === singleRequest?.field);
            let servicesArray = [];
            serviceObject.maintenanceListPerDevice.map((item,index)=>{
                item?.maintenanceList.map((service,index)=>{
                    servicesArray.push({label:service?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || service?.name?.ar, text: service?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || service?.name?.ar, value:service?.code, itemCode: service?.code, cost: service?.cost});
                })
            });
            setServices(servicesArray);
          } else {

          }
        } catch(err) {}
    }


    useEffect(()=>{
        if(id && searchParams && GetServiceByCode) {
            getSingleRequest();
        }
    },[id,searchParams,GetServiceByCode])

    useEffect(()=>{
        if(singleRequest) {
            getFields();
            let workerList = [];
            let workersWage = 0;
            if(singleRequest?.business) {
                workerList = singleRequest?.initialWorkList?.map(item=>({ itemCode: item?.maintenanceCode, quantity: item?.amount, text: GetServiceByCode(singleRequest?.field,item?.maintenanceCode)[1], cost: item?.cost }));
                workersWage = singleRequest?.initialWorkList.reduce((a, c) => a + c.cost, 0);
            } else {
                workerList = singleRequest?.maintenanceListHistory?.map(item=>({ itemCode: item?.maintenance?.code, quantity: item?.amount, text: item?.maintenance?.name, cost: item?.cost }));
                workersWage = singleRequest?.maintenanceListHistory.reduce((a, c) => a + c.cost, 0);
            }
            
            const finalData = {
                "requestId": singleRequest?._id,
                "workersWage": workersWage,
                "partsCost": singleRequest?.partsCost,
                "donation": 0,
                "workDoneList": workerList
            };
            
            setCompleteRequestData(finalData)
        }
    },[singleRequest])


    const removeFromList = (itemCode) => {
        setCompleteRequestData((prevData) => ({ ...prevData, workDoneList: prevData.workDoneList.filter((item) => item.itemCode !== itemCode) }));
    };

    const updateQuantity = (itemCode, quantity) => {
        if (quantity <= 0) {
        removeFromList(itemCode);
        return;
        }
        setCompleteRequestData((prevData) => ({
            ...prevData,
            workDoneList: prevData.workDoneList.map((item) =>
                item.itemCode === itemCode ? { ...item, quantity: quantity } : item
            )
         }));
    };

    const handleCloseModal = () => {
        setAddServiceModal(false);
    }

    const handleClickAddService = () => {
        setSelectedService(null);
        setAddServiceModal(true);
    }

    
    const handleClickAddServiceAction = () => {
        setCompleteRequestData((prevData) => ({
            ...prevData,
            workDoneList: [...prevData.workDoneList, {itemCode: selectedService?.itemCode, quantity: 1, text: selectedService?.text, cost: selectedService?.cost}]
         }));
         setAddServiceModal(false);
    }
    
    useEffect(()=>{
        if(selectedService) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    },[selectedService])

    

    const handleClickCompleteRequest = async () => {
        setIsActionLoading(true);
        if(compressedImage) {
            const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
            const storage = getStorage(app);
            const file = compressedImage;
            const time = Date.parse(moment().locale('en').format('YYYY-MM-DD HH:mm:ss')) / 1000;
            const storageRef = ref(storage,'VendorInvoice/'+time);
            const uploadTask = uploadBytesResumable(storageRef, file);
            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                },
                (error) => {
                    setIsActionLoading(false);
                    setToast({show:true,type:'error',message:t('completeRequest.imageUploadError')});
                },
                () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadedURL) => {
                    sendToServer(downloadedURL);
                });
                }
            );
        } else {
            sendToServer();
        }

    }

    const sendToServer = async (url=false) => {
        const body = {...completeRequestData};
        body.workersWage = completeRequestData?.workDoneList.reduce((a, c) => a + (c.cost* c.quantity), 0);
        body.partsCost = completeRequestData?.partsCost || 0;
        if (url) {
            body.partsCostInvoiceUrl = url;
        }
        if(singleRequest?.business) {
            body.businessSubRequest = true;
        }
        try {
            const response = await apiClient.patch(`/requests/costDetails`,body);
            if(response && response.status && (response.status === 201 || response.status === 200 || response.status === 204)) {
                if(singleRequest?.business) {
                    navigate(`/${i18n?.language || 'ar'}/requests/${id}?business=${singleRequest?.business}`)
                } else {
                    navigate(`/${i18n?.language || 'ar'}/invoice-status/${id}`)
                }
            } else {
              setIsActionLoading(false);
              setToast({show:true,type:'error',message:t('requests.errorOccurredRetry')});
            }
        } catch (error) {
            setIsActionLoading(false);
            setToast({show:true,type:'error',message: error?.response?.data?.message || t('requests.errorOccurredRetry')});
        }
    }

    useEffect(()=>{
        if(completeRequestData?.workDoneList?.length < 1) {
            setIsMainButtonDisabled(true);
        } else {
            setIsMainButtonDisabled(false);
        }
    },[completeRequestData])


    return (
        <>
        <PageHeader pageTitle={pageTitle} isColored />
        <PageMain>
            <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
            {(singleRequest && !isActionLoading) &&<MainContent>
                <NormalFormContainer fullWidth={true} heading={t('completeRequest.workDetails')} label={t('completeRequest.requiredWork')}>
                    <div className="relative w-full">
                        <div className="absolute top-[-70px] left-[-10px] text-blue bg-white rounded-[8px] border-[1px] border-blue text-[14px] font-[500] cursor-pointer px-[16px] leading-[37px] h-[37px]" onClick={handleClickAddService}><img src="/assets/images/add.svg" alt="" className="w-[16px] h-[16px] inline-block" /> {t('completeRequest.addService')}</div>
                    </div>

                    <div className="">
                        {completeRequestData?.workDoneList?.map((item,index)=>{
                            return (<div key={'workDoneList-'+index} className="flex flex-wrap lg:flex-nowrap bg-white mb-[24px]">
                                <div className="w-full lf:w-[50%] h-[46px] text-grey-900 text-[18px] leading-[25px]">
                                    {item?.text} <br />
                                    {item?.cost} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" />
                                </div>
                                <div className="w-full lg:w-[50%] h-[46px] text-grey-900 text-[14px] font-[500] text-end">
                                    <div className="inline-block w-[140px]">
                                        <div className="flex flex-nowrap gap-x-[0] mt-[10px] bg-grey-100 w-[140px] rounded-[30px] h-[32px] leading-[32px] select-none">
                                            <div className="text-end text-[18px] text-grey-900 w-[28px] h-[28px] cursor-pointer" style={{ background: "url('/assets/images/cart-delete.svg') center no-repeat"}} onClick={()=> item?.quantity > 1 ? updateQuantity(item?.itemCode,item?.quantity-1) : removeFromList(item?.itemCode,true)}></div>
                                            <div className="text-center text-[16px] font-[500] text-black w-[84px]">{item?.quantity}</div>
                                            <div className="text-end text-[18px] text-grey-900 w-[28px] h-[28px] cursor-pointer" style={{ background: "url('/assets/images/cart-add.svg') center no-repeat"}} onClick={()=>updateQuantity(item?.itemCode,item?.quantity+1)}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>)
                        })}
                    </div>

                    <div className="border-t-[1px] border-grey-200 pt-[24px]">
                        <div className="text-[16px] font-[500] text-grey-900">{t('completeRequest.spareParts')}</div>
                        <div className="relative w-full pt-[12px]">
                            <img src="/assets/images/SAR-med.svg" alt="" className="absolute end-[15px] w-[11px] bottom-[20px] z-[1] select-none" />
                            <InputField label={t('completeRequest.sparePartsCost')} placeholder={t('completeRequest.sparePartsCostPlaceholder')} value={completeRequestData?.partsCost} onChange={(e)=>{ if(e.target.value === '' || (e.target.value >= 0 && /^[0-9\b]+$/.test(e.target.value))) { setCompleteRequestData((prevData) => ({...prevData, partsCost: parseFloat(e.target.value) })) }}} />
                        </div>
                    </div>

                    <div className="pt-[24px] flex flex-wrap lg:flex-nowrap pb-[24px]">
                        <div className="w-full lg:w-[75%] leading-[37px] font-[500] text-[16px] text-grey-600">
                            {t('completeRequest.uploadInvoiceNote')}
                        </div>
                        <div className="w-full lg:w-[25%] text-end">
                            {completeRequestData?.partsCostInvoiceUrl 
                            ? <Link to={completeRequestData?.partsCostInvoiceUrl} target="_blank" className="text-blue bg-white rounded-[8px] border-[1px] border-blue text-[14px] font-[500] cursor-pointer px-[16px] leading-[37px] h-[37px] inline-block">{t('completeRequest.viewInvoice')}</Link>
                            : compressedImage 
                            ? <div className="relative text-blue bg-white rounded-[8px] border-[1px] border-blue text-[14px] font-[500] px-[16px] leading-[37px] h-[37px] inline-block">
                                {t('completeRequest.invoiceAdded')}
                            </div>
                            : <div className="relative text-blue bg-white rounded-[8px] border-[1px] border-blue text-[14px] font-[500] cursor-pointer px-[16px] leading-[37px] h-[37px] inline-block">
                                <input type="file" id="file" name="file" accept="image/*" ref={fileRef} onChange={handleChangeUpload} className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer" />
                                <img src="/assets/images/worker-request-icon.svg" alt="" className="w-[16px] h-[16px] inline-block me-[4px]" /> {t('completeRequest.addInvoice')}
                            </div>}
                        </div>
                    </div>


                    <div className="border-t-[1px] border-grey-200 pt-[24px]">
                        <div className="text-[16px] font-[500] text-grey-900 pb-[12px]">{t('requests.invoiceDetails')}</div>
                        <div className="p-[16px] rounded-[16px] border-[1px] border-grey-300">
                            <div className="flex flex-nowrap pb-[16px] border-b-[1px] border-dotted border-grey-300">
                                <div className="w-[50%] leading-[24px] h-[24px] text-grey-600 text-[16px] font-[500]">{t('completeRequest.totalServicesValue')}</div>
                                <div className="w-[50%] text-end leading-[24px] h-[24px] font-[500] text-[14px]">{completeRequestData?.workDoneList.reduce((a, c) => a + (c.cost* c.quantity), 0)} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                            </div>
                            <div className="flex flex-nowrap pb-[16px] pt-[16px] border-b-[1px] border-dotted border-grey-300">
                                <div className="w-[50%] leading-[24px] h-[24px] text-grey-600 text-[16px] font-[500]">{t('completeRequest.spareParts')}</div>
                                <div className="w-[50%] text-end leading-[24px] h-[24px] font-[500] text-[14px]">{completeRequestData?.partsCost || 0} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                            </div>
                            <div className="flex flex-nowrap pt-[16px]">
                                <div className="w-[50%] leading-[24px] h-[24px] text-grey-600 text-[16px] font-[500]">{t('completeRequest.grandTotal')}</div>
                                <div className="w-[50%] text-end leading-[24px] h-[24px] font-[500] text-[14px]">{Number(completeRequestData?.partsCost || 0) + Number(completeRequestData?.workDoneList.reduce((a, c) => a + (c.cost* c.quantity), 0) || 0)} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                            </div>
                        </div>
                        <div className="text-end pt-[24px]">
                            <NormalButton label={t('completeRequest.sendInvoiceToCustomer')}  isDisabled={isMainButtonDisabled} onClick={()=>handleClickCompleteRequest()} />
                        </div>
                    </div>

                </NormalFormContainer>
            </MainContent>}
        </PageMain>

        {addServiceModal && <ModalContainer heading={t('completeRequest.addServiceModal')} handleCloseModal={handleCloseModal} noOverFlow>
          <div className="">
            
            <div className="">
                <div className="">
                    <MultiSelect isMulti={false} label={t('completeRequest.chooseService')} placeholder={t('completeRequest.searchService')} options={services} value={selectedService?.value} onChange={(option)=>{setSelectedService(option)}} />
                </div>
            </div>
            <div className="w-full pt-[15px] text-end">
                <NormalButton label={t('requests.cancel')} color={'!bg-[transparent] !text-grey-400'} isDisabled={false} onClick={handleCloseModal} />
                <NormalButton label={t('completeRequest.add')}  isDisabled={isButtonDisabled} onClick={()=>handleClickAddServiceAction()} />
            </div>
          </div>
        </ModalContainer>}
        
        {(!singleRequest || isActionLoading) && <Loading showLoading={true} />}
        <Toast toast={toast} setToast={setToast} />
        </>
    )
}

export default CompleteRequset;
